import { arrayOf, bool, shape, string } from 'prop-types'

import { TENANT_AT, TENANT_COM } from 'shared/consts/tenants'
import { isEmpty } from 'shared/utils/objectUtils'
import { withI18n } from 'shared/utils/withI18n'
import Tenant from 'views/components/utils/Tenant'
import NowLabelWithZipInteractionContainer from 'views/containers/browser/NowLabelWithZipInteractionContainer'
import { isProductOutOfTrade } from 'views/utils/productUtils'
import {
  i18nType,
  publicRuntimeConfigType,
  redPointsType,
} from 'views/utils/propTypes'
import { trackingUrls } from 'views/utils/propTypes/adserver'
import { PromotionProductTypeV2 } from 'views/utils/propTypes/api'

import ProductLabelCommon from './ProductLabelCommon'
import ProductLabelOutOfTrade from './ProductLabelOutOfTrade'
import ProductLabelPrescription from './ProductLabelPrescription'
import ProductLabelPromotion from './ProductLabelPromotion'
import ProductLabelRedPoint from './ProductLabelRedPoint'

import './ProductLabels.scss'

/**
 * Component renders label only if stock status is not AV.
 * If status is equal AV, only `Out of trade` label will be displayed.
 */
const ProductLabels = ({
  displayNowWidget,
  i18n,
  labels,
  noLinksForPromotion,
  prescription,
  pharmaObl,
  promotion,
  promotionProduct,
  redPointsData,
  stockStatus,
  offerTypeSae,
  trackingUrls,
  upid,
}) => {
  const productLabelPromotionProps = {
    promotion,
    promotionProduct,
    offerTypeSae,
  }
  if (noLinksForPromotion) {
    productLabelPromotionProps.link = null
    productLabelPromotionProps.dataClientsideHook = null
  }

  /*
   * For tenant IT or FR we get a lot of duplicate labels from Algolia
   * Check SAEFRNT-4402 for more info
   */
  const finalLabels = labels?.length ? [...new Set(labels)] : []

  return (
    <ul className="a-list-reset a-list-inline o-ProductLabels">
      <ProductLabelPrescription prescription={prescription} />
      {finalLabels.map(label => (
        <ProductLabelCommon label={label} key={`flag-${label}`} />
      ))}
      {/*  Check SAEFRNT-4374 for more details - tbd. deprecation of pharmaObl  */}
      <Tenant tenant={[TENANT_AT, TENANT_COM]}>
        {() =>
          pharmaObl && (
            <ProductLabelCommon
              label={i18n._('product.label.pharmacistobligatory')}
            />
          )
        }
      </Tenant>
      <ProductLabelRedPoint redPointsData={redPointsData} />
      <ProductLabelPromotion {...productLabelPromotionProps} />

      {!isEmpty(trackingUrls) && (
        <ProductLabelCommon label={i18n._('general.label.sponsored')} />
      )}

      <NowLabelWithZipInteractionContainer
        displayNowWidget={displayNowWidget}
        upid={upid}
      />

      <ProductLabelOutOfTrade isOutOfTrade={isProductOutOfTrade(stockStatus)} />
    </ul>
  )
}

ProductLabels.propTypes = {
  publicRuntimeConfig: shape(publicRuntimeConfigType).isRequired,
  displayNowWidget: bool,
  i18n: i18nType.isRequired,
  labels: arrayOf(string),
  noLinksForPromotion: bool,
  pharmaObl: bool,
  prescription: bool,
  promotion: string,
  promotionProduct: PromotionProductTypeV2,
  redPointsData: redPointsType,
  stockStatus: shape({}),
  offerTypeSae: bool,
  trackingUrls,
  upid: string,
}

ProductLabels.defaultProps = {
  displayNowWidget: false,
  pharmaObl: false,
  prescription: false,
  promotion: null,
  promotionProduct: null,
  labels: null,
  noLinksForPromotion: false,
  offerTypeSae: true,
  redPointsData: null,
  stockStatus: {},
  trackingUrls: null,
  upid: null,
}

export default withI18n()(ProductLabels)
